import {
  APIProvider,
  Map
} from '@vis.gl/react-google-maps'
import { GMAPS_API_KEY } from '../../services/gmaps'
import { MarkerWithInfowindow } from './marker-with-infowindow'

const DEFAULT_ZOOM = 11

export interface Marker {
  lat: number
  lng: number
  title: string
  infoWindow?: JSX.Element
  pin?: JSX.Element
}

interface MapComponentProps {
  zoom?: number
  center: { lat: number, lng: number }
  mapId: string
  markers?: Marker[]
}

export function MapComponent ({ zoom, center, markers, mapId }: MapComponentProps): JSX.Element {
  // calculate zoom based on markers and center
  const calculateZoom = (): number => {
    if (markers == null || markers.length <= 1) {
      return DEFAULT_ZOOM
    }

    const latitudes = markers.map((marker) => marker.lat)
    const longitudes = markers.map((marker) => marker.lng)

    const maxLat = Math.max(...latitudes)
    const minLat = Math.min(...latitudes)
    const maxLng = Math.max(...longitudes)
    const minLng = Math.min(...longitudes)

    const latDiff = maxLat - minLat
    const lngDiff = maxLng - minLng

    const latZoom = Math.floor(Math.log2(360 / latDiff))
    const lngZoom = Math.floor(Math.log2(360 / lngDiff))

    return Math.min(latZoom, lngZoom)
  }

  return (
    <APIProvider
      apiKey={GMAPS_API_KEY}
      libraries={['marker']}
    >
      <Map
        defaultZoom={zoom != null ? zoom : calculateZoom()}
        defaultCenter={center}
        disableDefaultUI
        gestureHandling='greedy'
        mapId={mapId}
      >
        {markers?.map((marker, i) => (
          <MarkerWithInfowindow
            key={`marker-${i}-${marker.lat}-${marker.lng}`}
            lat={marker.lat}
            lng={marker.lng}
            title={marker.title}
            infoWindow={marker.infoWindow}
            customPin={marker.pin}
          />
        ))}
      </Map>
    </APIProvider>
  )
}
